import { combineReducers } from 'redux';
import authenticationReducer from './authenticationReducer';
import commonReducer from './commonReducer';
import networkReducer from './networkReducer';
import tariffReducer from './tariffReducer';
import tariffGroupReducer from './tariffGroupReducer';
import warrantyReducer from './warrantyReducer';
import agentReducer from './agentReducer';
import emissionReducer from './emissionReducer';
import contractReducer from './contractReducer';
import userReducer from './userReducer';
import customerReducer from './customerReducer';

const rootReducer = combineReducers({
    agentState: agentReducer,    
    authenticationState: authenticationReducer,    
    commonState: commonReducer,
    contractState: contractReducer,
    customerState: customerReducer,
    emissionState: emissionReducer,
    networkState: networkReducer,
    tariffState: tariffReducer,
    tariffGroupState: tariffGroupReducer,
    userState: userReducer,
    warrantyState: warrantyReducer
});

export default rootReducer;